/**
 * 未確定のカードの登録パネル（React の DOM）。灰色のカードを押すと出て、そのプレイヤーのデッキの一覧から押して選ぶ。
 * 置き場は盤の外（縦置きは下、横置きは右。prompt.dialogArea）。盤にかけず、盤も押し動かさない。
 * 並び次第でめくる効果（item.decktop。Issue #926）は、押すたびに上から 1 枚ずつ足し（サーバーが確定待ちで持つ）、「確定」で送る。
 */
import { playerColor, usePlayerColors } from './common';

export default function RegisterPanel({ item, deck = [], players, busy, area = null, onPick, onKeep, onClose }) {
  const colors = usePlayerColors();
  if (!item) return null;
  const color = playerColor(item.team, colors) ?? colors[0];
  // 盤の外の置き場（prompt.dialogArea。盤にかけない）。無ければ右の列
  const style = area?.style ?? { top: 8, right: 8, bottom: 8, width: 'min(300px, 40vw)' };
  const staged = item.decktop ? (item.decktop.staged ?? []).map((s) => s.name ?? String(s.code)) : null;
  const keepLabel = staged == null ? 'このままで OK' : staged.length ? `確定（${staged.join('・')}）` : 'このままで確定';
  return (
    <div data-testid="arena-register" data-side={area?.side ?? 'right'} style={{ position: 'absolute', ...style, zIndex: 6, display: 'flex', flexDirection: 'column', background: 'rgba(15,21,38,0.96)', color: '#e8eefc', minHeight: 0, minWidth: 0, border: '1px solid #2a3552', borderRadius: 12, boxShadow: '0 0 24px rgba(0,0,0,0.5)' }}>
      {/* 見出しは持たない（一覧を広く。登録しようとしているカードは盤の赤い枠で示す）。確定と閉じるだけ */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '6px 8px', borderBottom: '1px solid #2a3552' }}>
        <span style={{ width: 10, height: 10, borderRadius: 999, background: color, flexShrink: 0 }} />
        <button type="button" disabled={busy} onClick={onKeep} style={{ flex: 1, minWidth: 0, background: '#1b3a55', border: '1px solid #4fc3ff', color: '#e8eefc', borderRadius: 8, padding: '6px 10px', cursor: 'pointer', fontSize: 12, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{keepLabel}</button>
        <button type="button" aria-label="閉じる" onClick={onClose} style={{ background: 'none', border: '1px solid #345', color: '#e8eefc', borderRadius: 8, padding: '4px 10px', cursor: 'pointer', flexShrink: 0 }}>✕</button>
      </div>
      {staged != null ? (
        <div data-testid="register-decktop" style={{ padding: '4px 8px', fontSize: 12, borderBottom: '1px solid #2a3552' }}>
          上から順に押して確定（ここまで: {staged.length ? staged.join('・') : 'まだ無し'}）
        </div>
      ) : null}
      {/* 一覧: カードの真ん中だけを横長に切り出し（イラストの帯）、名前を重ねて 1 列に */}
      <div style={{ flex: 1, minHeight: 0, overflowY: 'auto', padding: 6, display: 'flex', flexDirection: 'column', gap: 4, scrollSnapType: 'y mandatory', overscrollBehavior: 'contain', scrollPaddingTop: 6 }}>
        {deck.length === 0 ? <div style={{ fontSize: 12, opacity: 0.7 }}>デッキの一覧がありません</div> : null}
        {deck.map((c) => {
          const current = String(item.code) === c.code;
          return (
            <button key={c.code} type="button" disabled={busy} title={c.name} onClick={() => onPick?.(Number(c.code))}
              style={{ position: 'relative', height: 44, flexShrink: 0, padding: 0, scrollSnapAlign: 'start', overflow: 'hidden', borderRadius: 6, cursor: 'pointer', textAlign: 'left',
                border: `2px solid ${current ? '#4fc3ff' : '#2a3552'}`, background: '#151c30', color: '#e8eefc' }}>
              {c.image ? <img src={c.image} alt="" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center 38%', display: 'block' }} /> : null}
              <span style={{ position: 'absolute', inset: 0, background: 'linear-gradient(90deg, rgba(5,6,12,0.9) 0%, rgba(5,6,12,0.75) 45%, rgba(5,6,12,0.15) 100%)' }} />
              <span style={{ position: 'relative', display: 'block', padding: '0 10px', lineHeight: '40px', fontSize: 13, fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {c.name}{c.count > 1 ? <span style={{ opacity: 0.8, fontWeight: 400 }}> ×{c.count}</span> : null}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
